import { addressEqual } from '@usedapp/core'

export function isAddressEqual(firstAddress: string | null | undefined, secondAddress: string | null | undefined) {
  return !!firstAddress && !!secondAddress && addressEqual(firstAddress, secondAddress)
}
